module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"btnText":"Télécharger l\u0027export des photos"},"en":{"btnText":"Download pictures export"}}')
  delete Component.options._Ctor
}
